import React from 'react';
import { StreamingOverviewResponse } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../../common/types';
import { PeriodSectionGateView } from '../../period/PeriodSectionGateView';
import { playSourcesMessages as messages } from '../../playSourcesMessages';
import { PlaySourcesBody } from './PlaySourcesBody';

interface PlaySourcesSectionProps {
  accountId: number;
  overview: StreamingOverviewResponse;
  onOpenCatalog: () => void;
}

/** Streaming → Play sources (design streaming-sections b1, b2, e2, e4): where the plays come from. */
const PlaySourcesSectionComponent: React.FC<PlaySourcesSectionProps> = ({ accountId, overview, onOpenCatalog }) => (
  <PeriodSectionGateView
    overview={overview}
    section="playSources"
    emptyTitle={messages.emptyTitle}
    emptyText={messages.emptyText}
    onOpenCatalog={onOpenCatalog}
  >
    <PlaySourcesBody accountId={accountId} days={overview.days} />
  </PeriodSectionGateView>
);

export const PlaySourcesSection = TypedMemo(PlaySourcesSectionComponent);
